import { getBaseUrl } from './urls.js';
export const getBase = async (httpClient) => {
    const { data } = await httpClient.get(getBaseUrl());
    return data;
};
